import {MutableRefObject} from 'react';

import {useAsyncEffect} from './useAsyncEffect';

export const useEffectOnce = (effect: (cancelRef?: MutableRefObject<boolean>) => void) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useAsyncEffect(effect, []);
};
